<template lang="pug" src="./custom-fun-cool-section.pug"></template>

<script>
import Title from 'components/block/block-title/block-title'

export default {
  props: ['props', 'app'],
  components: {
    Title
  }
}
</script>



// WEBPACK FOOTER //
// custom-fun-cool-section.vue?2e261bd8